/* Step 13 · P7 (lane S13A, owner answers 6 / 10, cards V3 / V5) — Founder → AI Keys → "Recent AI calls": every AI call of every firm with its model (Founder only;
   tenants never see a model). EN + AR. */
const I18N_S13P7 = {
  en: {
    s13p7: {
      title: "Recent AI calls",
      intro: "Every firm's AI runs, newest first: one row per AI run (the AI log). Founder only: the provider and the model are never shown to a firm.",
      firm: "Firm",
      allFirms: "Every firm",
      from: "From",
      to: "To",
      model: "Model",
      allModels: "Every model",
      apply: "Show",
      export: "Export XLSX",
      shown: "{shown} of {total} run(s)",
      none: "No AI calls for these filters.",
      status: { ok: "OK", error: "Failed" },
      retry: {
        failedBeforeLast: "{n} failed call(s) before the last",
        failed: "{n} failed call(s)",
        fallback: "fallback: the platform default key served the call (own platform key failed)",
        stopped: "stopped: the firm's own key failed (no fallback)",
        servedVia: "served via {routes}",
        sep: "; ",
        route: { platform: "platform key", byok: "firm's own key", own_key: "own platform key", proxy: "proxy" },
      },
      partial: "Retry / fallback read the newest usage and fallback records only; an older call of a long run may be missing.",
      feature: {
        ai_readout: "AI Readout", risk_ai_suggest: "AI suggest risks", dc_ai_premark: "Disclosure pre-mark",
        methodology_extract: "Methodology extraction / summary", assistant_chat: "AI assistant", form_ai_suggest: "Form AI suggest",
        fs_mapping_suggest: "FS mapping suggest", note_editorial_draft: "Note editorial draft", doc_extraction: "Document extraction",
        doc_summary: "Document summary", far_explanation: "Final analytical review — draft explanation",
        methodology_summary: "Methodology summary", methodology_settings_suggest: "Methodology settings suggestions",
        report_narrative: "Auditor's report narrative drafting",
        bulk_ai_suggest: "Forms AI suggest (all forms)", analytics_observations: "Analytics AI observations",
        report_narrative_draft: "Auditor's report narrative drafting", report_firm_adaptation: "Firm-style report wording",
        discrepancy_explain: "Discrepancy explainer", note_mapping_suggest: "AI suggest note mapping", unknown: "Uncategorised",
      },
      col: {
        when: "When (KSA)", firm: "Firm", engagement: "Engagement", feature: "Feature", provider: "Provider", model: "Model",
        status: "Status", calls: "Calls", units: "Units", retry: "Retry / fallback",
      },
    },
  },
  ar: {
    s13p7: {
      title: "أحدث استدعاءات الذكاء الاصطناعي",
      intro: "تشغيلات الذكاء الاصطناعي لكل الشركات، الأحدث أولاً: صف لكل تشغيل (سجل الذكاء الاصطناعي). للمؤسس فقط: لا يُعرض المزوّد ولا النموذج لأي شركة.",
      firm: "الشركة",
      allFirms: "كل الشركات",
      from: "من",
      to: "إلى",
      model: "النموذج",
      allModels: "كل النماذج",
      apply: "عرض",
      export: "تصدير XLSX",
      shown: "{shown} من {total} تشغيل",
      none: "لا توجد استدعاءات للذكاء الاصطناعي لهذه المرشحات.",
      status: { ok: "تم", error: "فشل" },
      retry: {
        failedBeforeLast: "{n} استدعاء فاشل قبل الأخير",
        failed: "{n} استدعاء فاشل",
        fallback: "بديل: خدم المفتاحُ الافتراضي للمنصة الاستدعاءَ (فشل مفتاح المنصة الخاص)",
        stopped: "توقف: فشل مفتاح الشركة الخاص (لا بديل)",
        servedVia: "خُدم عبر {routes}",
        sep: "؛ ",
        route: { platform: "مفتاح المنصة", byok: "مفتاح الشركة الخاص", own_key: "مفتاح المنصة الخاص", proxy: "الوسيط" },
      },
      partial: "قُرئت أحدث سجلات الاستخدام والبديل فقط لعمود إعادة المحاولة / البديل؛ قد يغيب استدعاء أقدم في تشغيل طويل.",
      feature: {
        ai_readout: "القراءة بالذكاء الاصطناعي", risk_ai_suggest: "اقتراح المخاطر بالذكاء الاصطناعي", dc_ai_premark: "التعليم المسبق لقائمة الإفصاحات",
        methodology_extract: "استخراج المنهجية / ملخصها", assistant_chat: "المساعد الذكي", form_ai_suggest: "اقتراح النماذج",
        fs_mapping_suggest: "اقتراح ربط القوائم", note_editorial_draft: "مسودة الإيضاح", doc_extraction: "استخراج المستندات",
        doc_summary: "ملخص المستند", far_explanation: "المراجعة التحليلية النهائية — مسودة التفسير",
        methodology_summary: "ملخص المنهجية", methodology_settings_suggest: "اقتراحات إعدادات المنهجية",
        report_narrative: "صياغة سرد تقرير المراجع",
        bulk_ai_suggest: "اقتراح الذكاء الاصطناعي لكل النماذج", analytics_observations: "ملاحظات التحليلات بالذكاء الاصطناعي",
        report_narrative_draft: "صياغة سرد تقرير المراجع", report_firm_adaptation: "صياغة التقرير بأسلوب الشركة",
        discrepancy_explain: "شرح الفروقات", note_mapping_suggest: "اقتراح ربط الإيضاحات", unknown: "غير مصنف",
      },
      col: {
        when: "الوقت (السعودية)", firm: "الشركة", engagement: "الارتباط", feature: "الميزة", provider: "المزوّد", model: "النموذج",
        status: "الحالة", calls: "الاستدعاءات", units: "الوحدات", retry: "إعادة المحاولة / البديل",
      },
    },
  },
};

export default I18N_S13P7;
